export default __webpack_public_path__ + "static/media/galaxy-s25-edge-icyblue.106926b4.jpg";